import { render, staticRenderFns } from "./FormatSectionSetup.vue?vue&type=template&id=4ff482b2&"
import script from "./FormatSectionSetup.vue?vue&type=script&lang=ts&"
export * from "./FormatSectionSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports